import { EAddressValidationType } from '../../address/validations.enum';
import { EJourneyPlanningProviderName } from '../../journey-planning/journey-planning-types.interfaces';
import {
  CONFIGURATION_SETTING_KEYS,
  ConfigurationSettingKey,
} from './configuration-setting-keys.constants';

export enum EConfigurationChannel {
  Web = 'WEB',
  App = 'APP',
}

export const CLIENT_CHANNEL_HEADER = 'Client-Channel';

export enum ESettingInputType {
  TextField = 'TEXTFIELD',
  NumberField = 'NUMBERFIELD',
  Checkbox = 'CHECKBOX',
  SingleSelect = 'SINGLESELECT',
  Url = 'URL',
  Icon = 'ICON',
  Custom = 'CUSTOM',
  MultiSelect = 'MULTISELECT',
}

export enum EPaymentProviders {
  Logpay = 'Logpay',
  Klarna = 'Klarna',
}

export enum EExistingCustomerRegistration {
  None = 'none',
  CustomerId = 'customerId',
  Token = 'token',
}

export enum ERelationSearchAccuracy {
  ByMinute = 'minutenscharf',
  ByDay = 'tagesscharf',
}

export enum EDirectSaleAlternatePassengerData {
  Salutation = 'Anrede',
  DateOfBirth = 'Geburtsdatum',
}

// Register configuration enums here so backend validateSelect() can validate allowed values.
export const CONFIGURATION_SELECT_OPTIONS_BY_SETTING_KEY: Partial<
  Record<ConfigurationSettingKey, string[]>
> = {
  [CONFIGURATION_SETTING_KEYS.RelationSearchAccuracy]: Object.values(
    ERelationSearchAccuracy
  ),
  [CONFIGURATION_SETTING_KEYS.PaymentProvider]:
    Object.values(EPaymentProviders),
  [CONFIGURATION_SETTING_KEYS.AddressValidationType]: Object.values(
    EAddressValidationType
  ),
  [CONFIGURATION_SETTING_KEYS.ExistingCustomerRegistration]: Object.values(
    EExistingCustomerRegistration
  ),
  [CONFIGURATION_SETTING_KEYS.JourneyPlannerProvider]: Object.values(
    EJourneyPlanningProviderName
  ),
  [CONFIGURATION_SETTING_KEYS.DirectSaleAlternatePassengerData]: Object.values(
    EDirectSaleAlternatePassengerData
  ),
};
